import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
    name: 'safeUrl'
})

export class SafeUrlPipe implements PipeTransform {
    constructor(private sanitized: DomSanitizer) {}
    transform(value: any) {
        return this.sanitized.bypassSecurityTrustResourceUrl(value);
    }
}


// WEBPACK FOOTER //
// ./src/app/common/pipes/safe-url.pipe.ts